import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, AlertColor, Snackbar } from "@mui/material";

interface FormData {
  email: string;
  password: string;
}

interface FormErrors {
  email?: string;
  password?: string;
}

interface SnackbarState {
  open: boolean;
  message: string;
  severity: AlertColor; // Explicitly typing the severity as AlertColor
}

const apiBase = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ? "http://localhost:3006"
  : "https://api.trubetx.com";

const LoginPage = () => {
  const [formData, setFormData] = useState<FormData>({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState<FormErrors>({});
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    severity: "success",
    message: "hello",
    open: false,
  });
  const navigate = useNavigate();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const validateForm = (): boolean => {
    let valid = true;
    let errors: FormErrors = {};

    if (!formData.email) {
      valid = false;
      errors.email = "Email is required";
    }
    if (!formData.password) {
      valid = false;
      errors.password = "Password is required";
    }

    setErrors(errors);
    return valid;
  };

  const handleCloseSnackbar = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const loginClick = async () => {
    if (!validateForm()) {
      return; // Form validation failed, do not proceed with login
    }

    try {
      // Make the API call to the login endpoint
      let result = await axios.post(`${apiBase}/admin/login`, {
        email: formData.email,
        password: formData.password,
      });

      // Check if the response contains the token
      if (result.data.token) {
        console.log(result.data,"result.data")
        // Store the token in localStorage (or sessionStorage, depending on your preference)
        localStorage.setItem("token", result.data.token);
        localStorage.setItem("role", result.data.role);
        localStorage.setItem("uid", result.data.uid);
        localStorage.setItem("name", result.data.name);
        localStorage.setItem("email", result.data.email);

        // Redirect the user to the home page or any other protected route
        window.location.href = "/"; // Adjust the redirect URL as needed
      } else {
        setSnackbar({
          severity: "error",
          message: "Token not found in response",
          open: true,
        });
      }
    } catch (error) {
      // Handle errors that may occur during the login attempt
      const message =
        error.response?.data?.message || "Something went wrong...";
      setSnackbar({ severity: "error", message, open: true });
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    loginClick();
  };

  return (
    <>
      <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-[#d7d7d7] min-h-screen  text-white">
        <div className=" bg-white max-w-[550px] w-full space-y-4  shadow  rounded-lg p-10 ">
          {/* <div className="mb-8 flex justify-center">
            <img
              className="w-40"
              src="/logo.webp"
              alt=""
            />
          </div> */}
          <form className="mt-8 space-y-4" onSubmit={handleSubmit}>
            {/* Email Field */}
            <div className="mb-2">
              <label className="text-black font-[400]">User Name</label>
              <input
                type="email"
                name="email"
                id="email"
                autoComplete="email"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 mt-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && (
                <p className="text-red-500 text-xs italic">{errors.email}</p>
              )}
            </div>

            {/* Password Field */}
            <div className="mb-2">
            <label className="text-black font-[400]">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                autoComplete="new-password"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 mt-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && (
                <p className="text-red-500 text-xs italic">{errors.password}</p>
              )}
            </div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#228BE6]  focus:outline-none"
            >
              Login
            </button>
          </form>
          {/* Footer */}
        </div>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={2500}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default LoginPage;
